/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DefaultEnvs,
  APIEnvs,
  EndPointsNames,
  ApiType,
  DefaultAPIEnvs,
} from '_core/types';
import { Logger } from '../logger';

type KeyTypes = {
  name: EndPointsNames;
  endpoint: string;
  environment: DefaultEnvs;
  type: ApiType;
};
type itemTypes = KeyTypes[];

type stackInstances = {
  [envs in APIEnvs]: itemTypes;
};

const getStackInstances = (): stackInstances => {
  const apis: any = {};
  Object.entries(DefaultAPIEnvs).forEach(([key, value]) =>
    value.forEach((v: string | number) => {
      apis[String(v)] = [
        {
          name: 'ApiLaunchdarkly',
          endpoint: 'https://app.launchdarkly.com/',
          environment: key,
          type: 'Smiles-Launchdarkly',
        },
      ];
    }),
  );

  apis?.PRD.push({
    name: 'ApiFileEnvironment',
    endpoint: 'https://www.smiles.com.br/',
    environment: 'production',
    type: 'Smiles-FileEnvironment',
  });

  const mocks = apis?.MOCK;
  apis?.MOCK.push.apply(
    mocks,
    [
      {
        name: 'ApiAccount',
      },
      {
        name: 'ApiMain',
      },
      {
        name: 'ApiPartner',
      },
      {
        name: 'ApiLiferay',
        type: 'Smiles-Liferay',
      },
      {
        name: 'ApiGoogle',
        endpoint: 'https://maps.googleapis.com/maps/api/',
        type: 'Google',
      },
    ].map((v) => {
      return {
        name: v.name,
        endpoint: v?.endpoint || 'http://mock.main.local/',
        environment: 'development',
        type: v?.type || 'Smiles',
      };
    }),
  );

  return apis;
};

const _Apis: stackInstances = getStackInstances();

const _Headers = {
  'Content-Type': 'application/json',
};

export const getEndPoints = (pEvironment: APIEnvs) => {
  return _Apis[pEvironment];
};
export const getPropApi = (
  pEvironment: APIEnvs,
  name: string,
): {
  apiType: ApiType;
  endpoint: string;
} => {
  let apiType: ApiType = 'Smiles';
  let endpoint = '#';
  const apis = _Apis[pEvironment];
  const lstResult = apis.filter((api) => api.name === name);
  if (lstResult && lstResult.length > 0) {
    apiType = lstResult[0].type;
    endpoint = lstResult[0].endpoint;
  }
  return { apiType, endpoint };
};

export const updateEndpoints = (environment: APIEnvs, dados: any): boolean => {
  try {
    const endpoints = [..._Apis[environment], ...dados];
    _Apis[environment] = endpoints;
  } catch (error) {
    Logger.error(error);
    return false;
  }
  return true;
};

export const Headers = () => _Headers;
